module.exports = __webpack_public_path__ + "img/access_controls.2e12bfc2.png";